module.exports = __webpack_public_path__ + "img/icon_upload.c8c90694.png";